// simulator/utils/dondeAyuda.js
// COPIA POR VALOR de aws_lambdas/c_clientInsightsNightly/dondeAyuda.js (la regla de «Dónde te ayuda» de «Tu agenda
// llena»), en ESM para el simulador de ventas: con los datos de ejemplo, la demo calcula `resumen.donde_ayuda` con
// la MISMA regla que el cálculo nocturno. El cuerpo (de «Qué parte de cada grupo» hasta el export) es idéntico al
// del lambda: lo vigila __tests__/agendaLlena.copia.test.js. Si cambias la regla, cámbiala en los dos.
// Qué parte de cada grupo suele volver con un aviso. Estimaciones prudentes para ORDENAR las tarjetas, no para
// prometer: la pantalla dice «aprox.» y el embudo mide lo real.
const TASA = { volver: 0.3, nuevo: 0.2, perdido: 0.1, hueco: 0.3 };
// Por debajo de esto no se le dice a nadie que la función le ayuda: no hay bolsa (citas estimadas).
const MINIMO_CITAS = 2;

const n = (v) => Number(v) || 0;

/**
 * @param {{ summary: {por_tarjeta?:object, huecos?:Array, ticket_medio?:number|null}, clients: Array }} p
 * @returns {{ tipo: "volver"|"nuevo"|"perdido"|"hueco"|"al_dia", count: number, citas_aprox: number,
 *   euros_aprox: number|null, hueco?: object|null, secundaria?: string|null, con_cita_pct?: number|null }}
 */
function dondeAyuda({ summary = {}, clients = [] } = {}) {
  const pt = summary.por_tarjeta || {};
  const ticket = n(summary.ticket_medio) > 0 ? n(summary.ticket_medio) : null;

  // Huecos con alguien a quien avisar: cada hueco se puede llenar como mucho con sus candidatos.
  const huecos = (summary.huecos || []).filter((h) => h && n(h.libres) > 0 && (h.candidatos || []).length > 0);
  const llenables = huecos.reduce((s, h) => s + Math.min(n(h.libres), h.candidatos.length), 0);
  const mejorHueco = [...huecos].sort((a, b) => Math.min(n(b.libres), b.candidatos.length) - Math.min(n(a.libres), a.candidatos.length) || String(a.day).localeCompare(String(b.day)))[0] || null;

  const opciones = [
    { tipo: "volver", count: n(pt.volver) },
    { tipo: "nuevo", count: n(pt.nuevo) },
    { tipo: "perdido", count: n(pt.perdido) + n(pt.retrasado) },
    { tipo: "hueco", count: llenables },
  ].map((o) => ({ ...o, citas: o.count * TASA[o.tipo] }))
    // A igualdad, el orden de arriba: avisar a quien le toca es lo más natural.
    .sort((a, b) => b.citas - a.citas);

  const [mejor, segunda] = opciones;
  if (!mejor || mejor.citas < MINIMO_CITAS) {
    // Clientes «vivos» (vinieron en los últimos 90 días o tienen cita): qué parte ya tiene su próxima cita.
    const vivos = clients.filter((c) => c && n(c.visitas) >= 1 && (c.cita_futura || c.tarjeta === "al_dia" || c.tarjeta === "nuevo"));
    const conCita = vivos.filter((c) => c.cita_futura).length;
    return { tipo: "al_dia", count: 0, citas_aprox: 0, euros_aprox: null, con_cita_pct: vivos.length ? Math.round((100 * conCita) / vivos.length) : null };
  }
  const citas = Math.round(mejor.citas);
  return {
    tipo: mejor.tipo,
    count: mejor.count,
    citas_aprox: citas,
    euros_aprox: ticket ? Math.round(citas * ticket) : null,
    hueco: mejor.tipo === "hueco" && mejorHueco ? { day: mejorHueco.day, franja: mejorHueco.franja, worker: mejorHueco.worker, candidatos: mejorHueco.candidatos.length } : null,
    secundaria: segunda && segunda.citas >= MINIMO_CITAS ? segunda.tipo : null,
  };
}

export { dondeAyuda, TASA, MINIMO_CITAS };
